import ResourceCardsView from '../ResourceList/ResourceCardsView';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { CategoryCard, CategoryCardGlobal } from './CategoryCards';
import { getUser } from '../../utils/tokens'
import { loadImages } from '../../utils/FileHelper';
import { FolderIcon } from '@heroicons/react/24/outline';
import * as R from 'ramda';
import {filter, find} from "rambda";

const getSubCategoriesUrl = categoryId => `/resource/v1/resource-categories/${categoryId}`;
const globalListUrl = clientId => `resource/v1/resource-categories/clients/${clientId}?global=true`;
const getImgUrl = id => `/resource/v1/resources/${id}/file/${id}`;

const CategoryDisplayPage = ({ subCategories, local, parentCategory }) => {
	const [hasResources, setHasResources] = useState(true);

	const updateResources = value => {
		setHasResources(value);
	};

	return (
		<div className="relative px-4 pb-6 sm:px-6 lg:px-8 lg:pt-8">
			<h2 className="text-4xl font-bold tracking-tight text-gray-900">
				{parentCategory.title}
			</h2>
			<ResourceCardsView local={local} updateResources={updateResources} />
			{subCategories.length > 0 && (
				<div className="relative px-4 sm:px-6 lg:px-8 lg:pt-8">
					<div className="text-left pt-8">
						<h2 className="text-3xl font-bold tracking-tight text-gray-900">Categories</h2>
					</div>
					<div className="mx-auto mt-12 grid max-w-lg gap-5 lg:max-w-none lg:grid-cols-3">
						{subCategories.map(category =>
							local ? (
								<CategoryCard key={category.id} category={category} />
							) : (
								<CategoryCardGlobal key={category.id} category={category} />
							),
						)}
					</div>
				</div>
			)}
			{!subCategories.length && !hasResources && (
				<div className="col-span-12 mx-auto my-56">
					<FolderIcon className="my-0.5 h-40 text-gray-200 mx-auto" />
					<h1 className="text-2xl text-center text-gray-400">
						You don&apos;t have any items in this category.
					</h1>
				</div>
			)}
		</div>
	);
};

const CategoryDisplay = () => {
	const [categories, setCategories] = useState(null);
	const [parentCategory, setParentCategory] = useState(null);
	const [imagesLoaded, setImagesLoaded] = useState(false);
	const params = useParams();
	const categoryId = params.categoryId;
	const local = params.type === 'local';
	const currentUser = getUser();

	useEffect(() => {
		let filtered;
		const getCategories = async () => {
			return await axios
				.get(globalListUrl(currentUser.clientIdNum))
				.then(response => {
					filtered = R.filter(c => c.enabled, response.data);

					const parentCat = find(c => {
						return Number(categoryId) === c.id;
					}, filtered);

					if (parentCat) {
						setParentCategory(parentCat);
					}
				})
				.catch(error => {
					console.log(error);
				});
		};

		getCategories().then();
	}, [params.categoryId]);

	useEffect(() => {
		const fetchCategories = () => {
			axios({
				method: 'GET',
				url: getSubCategoriesUrl(categoryId),
			}).then(
				response => {
					if (response.data.length > 0) {
						loadImages({ url: getImgUrl, objects: response.data, setImagesLoaded: setImagesLoaded }).then(
							response => {
								if (response !== null) {
									const filtered = R.filter(c => c.enabled, response);
									setCategories(filtered);
								}
							},
							error => {
								console.log(error); // zzmatt
							},
						);
					} else {
						setImagesLoaded(true);
						setCategories(response.data);
					}
				},
				error => {
					console.log(error);
				},
			);
		};

		if (categoryId) {
			fetchCategories();
		}
	}, [params.categoryId]);

	if (!imagesLoaded || !parentCategory) {
		return <div>Loading</div>;
	}

	if (categories && imagesLoaded && parentCategory) {
		return <CategoryDisplayPage parentCategory={parentCategory} subCategories={categories} local={local} />;
	}
};

export default CategoryDisplay;
